import { InputField } from '../../shared/models';

export interface AlertCommunicationInfo {
    communicationMethod: string;
    sendTextAlert: InputField<boolean>;
    sendEmailAlert: InputField<boolean>;
    optOutFromAlerts: InputField<boolean>;
    emailAddress: InputField<string>;
    cellPhone: InputField<string>;
}